import moment from 'moment';
import StatDateFormats from './types/DateFormats';

const momentUtc = (
  date: Date | string | number,
  format = StatDateFormats.DaySimple,
  isDisplayOnly = false,
): string => {
  if (!date && isDisplayOnly) {
    return '--';
  }
  const parsedDate = moment(date).utc().format(format);
  return parsedDate === 'Invalid date' && isDisplayOnly ? '--' : parsedDate;
};

export const momentUtcStartOfDay = (date: Date | string | number): string => {
  return moment
    .utc(date, StatDateFormats.DaySimple, true)
    .startOf('day')
    .format(StatDateFormats.IsoDateTime);
};

export default momentUtc;
